import Vue from 'vue'

/**
 * @author Suhipney R. <suhiipney@gmail.com>
 *
 * @param user and passworduser user to update
 *
 * Update an existing user
 * @return {Object} Updated user info
 */

const passwordTransformer = ({ password, password2 }) => {
  return {
    password,
    'confirmed_password': password2
  }
}

export default ({ username, ...password }) =>
  Vue.$http.post(`/users/${username}/change_password/`, passwordTransformer(password))
    .then((res) => res.data)
